function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: 1px;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M327,318l154,6c13.859,2.584,35.941-1.755,42,5,6.617,11.068-4.514,106.882-13,121l-22,22c-5.366,14.5-.6,33.73-9,45v-2l-19-26h-1c-1.112-.512-112.981-2.992-118-1-15.048,5.973-16.232,25.111-34,31,5.561-12.763,6.464-29.9,8-47l-6-2c3.53,15.955-4.127,36.823-6,53-17.126,5.062-36.173,6.62-52,14q3.5-60.494,7-121c-9,9.934-11.053,100.776-11,123l-5,1c-0.727-78.4,12.864-138.516,18-206,8.727,3.227,15.5,5.639,21,12q0.5-7,1-14c8.991,0.112,12.529-7.029,21-10ZM450,507l2,2Z"
});

var SvgFHairstyleStraightLongBackVector = function SvgFHairstyleStraightLongBackVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_hairstyle_straight_long_back_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFHairstyleStraightLongBackVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_hairstyle_straight_long_back_vector.c817dd1c.svg";
export { ForwardRef as ReactComponent };